function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { Typography } from 'antd';
import { FontWeightEnum } from "./index";
import useStyles from "./style";
var Title = Typography.Title;
function AelfdTitle(props, ref) {
  var _props$fontWeight = props.fontWeight,
    fontWeight = _props$fontWeight === void 0 ? FontWeightEnum.Regular : _props$fontWeight,
    level = props.level;
  var titleLevel = level && level > 5 ? 5 : level;
  var _useStyles = useStyles({
      fontFamily: fontWeight,
      level: level || 7
    }),
    styles = _useStyles.styles,
    cx = _useStyles.cx;
  return /*#__PURE__*/React.createElement(Title, _extends({}, props, {
    ref: ref,
    level: titleLevel,
    className: cx(styles.AelfDesignTitle, props.className)
  }));
}
export default /*#__PURE__*/React.forwardRef(AelfdTitle);